

import React, { FC } from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import Link from 'src/components/router/link';

const clsPrefix = 'app-nav-logo';

const Variant = {
  default: 'default',
  theme: 'theme',
  purple: 'purple',
  compass: 'compass',
} as const;

type Variant = typeof Variant[keyof typeof Variant];

interface NavLogoProps {
  className?: string;
  routeName?: string;
  href?: string;
  variant?: Variant;
  ariaLabel?: string;
  routeParams?: any;
}

const NavLogo: FC<NavLogoProps> = (props) => {
  const {
    className,
    routeName = 'home',
    routeParams,
    href,
    variant = 'default',
    ariaLabel = 'Glide',
  } = props;

  const clsName = classNames(
    clsPrefix,
    className,
    'test__home',
    `${clsPrefix}--${variant}`
  );

  if (variant === Variant.compass) {
    return <span className={clsName} aria-label={ariaLabel} />;
  }

  if (href) {
    return <a href={href} className={clsName} aria-label={ariaLabel} />;
  }

  return (
    <Link
      className={clsName}
      routeName={routeName}
      routeParams={routeParams}
      ariaLabel={ariaLabel}
    >
      <span>Glide</span>
    </Link>
  );
};

export default observer(NavLogo);
